export default __webpack_public_path__ + "5e265b2dd125ba045ee2b60de116d3f4.png";